export default __webpack_public_path__ + "static/media/Beard_11_C2.33ac1ab6.svg";